import { browser } from '$app/environment';
import { signInUpModalStore } from '@app/stores/signInUpModal';
import { get } from 'svelte/store';

export function fetchInterceptor() {
	if (!browser) {
		return;
	}
	const originalFetch = window.fetch;
	window.fetch = async (input, init) => {
		const response = await originalFetch(input, init);
		if (response.status === 401) {
			signInUpModalStore.open();
			get(signInUpModalStore).isOpenFromProtectedRoute = true;
		}
		return response;
	};
}
